// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__t9euF","noInteraction":"EventWrapper_noInteraction__126aS"};